import apiService from './apiService';

export async function applyForEconPermission(id: string) {
  return apiService.post(`programs/emails`, {
    programId: id,
    operation: 'APPLY_FOR_PERMISSION'
  });
}
